/**
 * Disambiguates top-level main-menu bold state when a submenu link is
 * cross-listed under more than one top-level dropdown (e.g. "Arpoador"
 * appears under both MEN and SANDALS). Shopify's own active/child-active
 * detection is purely URL based, so every menu containing that link gets
 * flagged - this only intervenes when there's a genuine conflict, and uses
 * whichever top-level menu the visitor actually clicked through to decide
 * which one should stay bold.
 */
(function () {
    var STORAGE_KEY = 'vejaLastClickedTopMenuIndex';

    document.addEventListener('DOMContentLoaded', function () {
        var topList = document.querySelector('#headerGrid ul[menu-list="1"]');
        if (!topList) return;

        var topItems = Array.prototype.filter.call(topList.children, function (el) {
            return el.tagName === 'LI';
        });

        function isCandidateActive(li) {
            var a = li.querySelector(':scope > a.button');
            if (a && a.getAttribute('data-active') === 'true') return true;

            var summary = li.querySelector(':scope > details > summary');
            if (summary && (summary.getAttribute('data-active') === 'true' || summary.getAttribute('data-child-active') === 'true')) {
                return true;
            }

            return false;
        }

        // Only step in when more than one top-level item is claiming to be active -
        // that's the actual conflict (e.g. MEN and SANDALS both bold because a
        // cross-listed collection is the current page).
        var candidates = topItems.filter(isCandidateActive);

        if (candidates.length > 1) {
            var storedRaw = sessionStorage.getItem(STORAGE_KEY);
            var storedIndex = storedRaw !== null ? parseInt(storedRaw, 10) : -1;
            var storedLi = (storedIndex >= 0 && storedIndex < topItems.length) ? topItems[storedIndex] : null;

            if (storedLi && candidates.indexOf(storedLi) !== -1) {
                candidates.forEach(function (li) {
                    if (li !== storedLi) {
                        li.setAttribute('data-js-force-nobold', 'true');
                    }
                });
            }
            // If we don't have a reliable stored menu (e.g. direct URL visit),
            // leave the default behaviour as-is rather than guessing.
        }

        // Remember which top-level menu a click actually happened under, so the
        // correct one can be favoured after the page navigates.
        //
        // NOTE: this listener is attached to `document` (not `topList`) and
        // registered in the capture phase. header.liquid has its own capture-phase
        // handler on the <header> element that calls stopPropagation() for
        // ".menu-top-link" clicks (i.e. clicking a top-level item's own link,
        // like "KIDS" itself) to force navigation. Since <header> is an ancestor
        // of the menu list, its capture listener always fires first and would
        // block a listener attached to `topList` before it ever runs. Attaching
        // to `document` guarantees we run before `header`'s handler, so we still
        // capture the click even when it's intercepted and stopped further down.
        document.addEventListener('click', function (e) {
            var link = e.target.closest('a[href]');
            if (!link || !topList.contains(link)) return;

            var el = link;
            while (el && el.parentElement !== topList) {
                el = el.parentElement;
            }
            if (!el) return;

            var index = topItems.indexOf(el);
            if (index !== -1) {
                sessionStorage.setItem(STORAGE_KEY, String(index));
            }
        }, true);
    });
})();
